export default __webpack_public_path__ + "static/media/Chill of Winter's Breath (dexterity).125bfdcc.jpg";